import { getBoolean, returnEmpty } from "@core/_utils/tools.utils";

export class HeaderBasket {
    name: string;
    label: string;
    desc: string;
    userListUsed: [];
    groupListUsed: [];
    duplicate: boolean;

    public Clear() {
        this.name = '';
        this.label = '';
        this.desc = '';
        this.userListUsed = [];
        this.groupListUsed = [];
        this.duplicate = false;
    }

    public loadData(adata) {
        this.name = adata.Information.Name;
        this.desc = adata.Information.Description;
        this.label = adata.Information.Label;
        this.groupListUsed = this.getGroupList(adata.Rights.GroupList);
        this.userListUsed = this.getGroupList(adata.Rights.UserList);
    }

    public getGroupList(aData) {
        let wGrpList = '';
        if (Array.isArray(aData)) {
            return [];
        } else {
            wGrpList = returnEmpty(aData);
            if (wGrpList !== '') {
                return aData.split(',')
            } else {
                return [];
            }        
        }
    }
}
